import React, { useEffect, useState } from 'react'

import { Typography } from '@material-ui/core'

import useFetch from 'hooks/useFetch'

import * as service from 'service'

const ResponsibleUsersDisplay = ({
  dataProcessId,
  otherAssigneesDescription,
}) => {
  const [responsiblesNames, setResponsiblesNames] = useState([])
  const names = [...responsiblesNames]

  const { response } = useFetch(
    service.dponet.dataProcesses.getProcessResponsibles,
    { dataProcessId },
    [dataProcessId],
    !!dataProcessId,
  )

  useEffect(() => {
    if (response) {
      const responsibleList = response.data.dataProcessResponsibles || []

      const responsibleUserNames = responsibleList.map(
        (item) => item.responsible?.name,
      )

      setResponsiblesNames(responsibleUserNames)
    }
  }, [response])

  const getResponsibleUserString = () => {
    if (otherAssigneesDescription) {
      names.push(otherAssigneesDescription)
    }

    if (names.length === 0) return 'Nenhum responsável'

    return names.join(', ')
  }

  return (
    <Typography color="textPrimary" variant="body2">
      {getResponsibleUserString()}
    </Typography>
  )
}

export default ResponsibleUsersDisplay
